import { MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { FieldType, OptionType } from "../../../services/helpers/types";
import { useDispatch } from "react-redux";

interface SelectFieldProps {
  field?: FieldType;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const SelectField = (props: SelectFieldProps) => {
  const { field, value = "", placeholder, disabled, onChange } = props;
  const dispatch = useDispatch();
  const [options, setOptions] = useState<OptionType[]>([]);

  useEffect(() => {
    if (field?.options) {
      setOptions(field.options);
    }
  }, [field, dispatch]);

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="dui-select-wrapper">
      <Select
        className="dui-select"
        value={options.length > 0 && value !== null ? value : ""}
        onChange={handleSelectChange}
        placeholder={placeholder}
        disabled={disabled}
      >
        {options.length > 0
          ? options.map((option, index) => (
              <MenuItem
                key={index}
                value={option.value}
                className="dui-select-item"
              >
                {option.name}
              </MenuItem>
            ))
          : null}
      </Select>
    </div>
  );
};

export default SelectField;
